module.exports = __webpack_public_path__ + "static/media/Challenge.76bc9f11.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Wealth/img/Challenge.png
// module id = 702
// module chunks = 0